export enum Scope {
  CompanyScope = 0,
  TeamPrivateScope = 1,
  TeamPublicScope = 2,
}
